import { fetchVersionSuccessAction } from '.'
import { Config } from '../utils/config'

const fetchVersion = async (dispatch, throwAsyncError) => {
  try {
    const response = await fetch(
      `${Config.BASE_URL}/version`,
      {
        method: 'GET',
        credentials: 'include'
      }
    )

    const requestId = response.headers.get('X-Request-ID')

    if (!response.ok) {
      const error = new Error(`HTTP error! Status: ${response.status}`)
      error.status = response.status
      error.requestId = requestId
      throw error
    }

    const result = await response.json()
    dispatch(fetchVersionSuccessAction(result))
  } catch (error) {
    throwAsyncError(error)
  }
}

export { fetchVersion }
